import styled from 'styled-components'
import vars from 'scss/variables.js'

const { colorGrey6, white } = vars

export const Container = styled.ol`
  padding-left: 8px;
`

export const List = styled.li`
  display: inline-flex;
  color: ${colorGrey6};
  font-size: 10px;

  &:after {
    content: '>';
    padding: 0 10px;
    font-style: normal;
  }

  &:last-child {
    font-size: 10px;
    font-weight: 600;

    &:after {
      content: none;
    }

    a {
      pointer-events: none;
    }
  }

  .theme--blackfair & {
    color: ${white};
  }

  a {
    color: ${colorGrey6};

    .theme--blackfair & {
      color: ${white};
    }
  }
`
